<ptl-v3-content-card
  [item]="cardItem()"
  [reserveRows]="reservedRows()"
  view="list"
  [joinBusy]="join.busy()"
  (cardClicked)="onCardOpen()"
  (joinClicked)="join.act()"
></ptl-v3-content-card>
